<template>
  <div class="product-footer">
    <div class="pagination">
      <a class="prew" @click="prev()" :class="{disabled: isFirstProduct}">предыдущая</a>
      <p class="page-num" @click="goToCatalog()">{{productIndex}}</p>
      <a class="next" @click="next()" v-if="!isLastProduct">следущая</a>
      <!-- <a class="next" href="/manufacture-order" v-else>Завершить</a> -->
      <a class="next" @click.prevent="$router.push('/manufacture-order')" v-else>Завершить</a>
    </div>
  </div>
</template>
<script>
export default {
  props: ["collection", "element", "productInfo"],
  data: () => ({
    productIndex: 35
  }),
  methods: {
    goToCatalog(){
      this.$router.push('/control-catalog/');
    },
    next(){
      let collectionProducts = this.$localStorageGet('currentCollection').find(x => x.id == this.collection); //Информация о текущей коллекции
      let currentIndex = collectionProducts.products.findIndex( el => el.id == this.element); //Индекс текущего товара в объекта товаров коллекции
      let nextProductID = collectionProducts.products[currentIndex + 1].id;
      this.$router.push('/control-detail/'+this.collection+'/'+nextProductID);
    },
    prev(){
      let collectionProducts = this.$localStorageGet('currentCollection').find(x => x.id == this.collection); //Информация о текущей коллекции
      let currentIndex = collectionProducts.products.findIndex( el => el.id == this.element); //Индекс текущего товара в объекта товаров коллекции
      let prevProductID = collectionProducts.products[currentIndex - 1].id;
      this.$router.push('/control-detail/'+this.collection+'/'+prevProductID);
    },
  },
  computed: {
    isFirstProduct(){ //Заблокировать кнопку "назад" на первом элементе
      let currentCollection = this.$localStorageGet('currentCollection').find( el => el.id == this.collection);
      if(currentCollection.products.findIndex( el => el.id == this.element) == 0){
        this.$emit('firstProduct', true)
        return true
      }else{
        this.$emit('firstProduct', false)
        return false
      }
    },
    isLastProduct(){
      let currentCollection = this.$localStorageGet('currentCollection').find( el => el.id == this.collection);
      let totalProducts = currentCollection.products.length;
      this.productIndex = currentCollection.products.findIndex( el => el.id == this.element) + 1;
      if(currentCollection.products.findIndex( el => el.id == this.element) == (totalProducts - 1)){
        this.$emit('lastProduct', true)
        return true
      }else{
        this.$emit('lastProduct', false)
        return false
      }
    }
  },

  
};
</script>
<style lang="scss" scoped>
  .disabled{
    opacity: 0.3;
    pointer-events: none;
  }
</style>